import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const ProjectTextInfo = ({ columns, verticalPadding, titleTag = "h2" }) => {
	const TitleTag = titleTag;
	const sizeModifiers = {
		large: "project-text-info__column--large"
	};

	const verticalPaddingModifiers = {
		small: "project-text-info__wrapper--small-vertical-padding"
	};

	return (
		<section className="project-text-info">
			<div
				className={
					classNames("project-text-info__wrapper container container--medium", verticalPaddingModifiers[verticalPadding])
				}
			>
				<div className="project-text-info__columns">
					{columns.map(({ title, description, columnSize }, index) => {
						return (
							<div
								key={index}
								className={
									classNames("project-text-info__column", sizeModifiers[columnSize])
								}
							>
								<TitleTag className="project-text-info__item-title medium-title">
									{title}
								</TitleTag>

								<div
									className="project-text-info__item-content"
									dangerouslySetInnerHTML={{
										__html: description
									}}
								/>
							</div>
						);
					})}
				</div>
			</div>
		</section>
	);
};

ProjectTextInfo.propTypes = {
	columns: PropTypes.array.isRequired,
	verticalPadding: PropTypes.string.isRequired,
	titleTag: PropTypes.oneOf(["h2", "h3"])
};

export default ProjectTextInfo;
